{
  "common": {
    "apply": "Aplicar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "search": "Buscar",
    "showMore": "Mostrar más",
    "vs": "vs",
    "ofTotal": "{{percentage}}% del total",
    "showingItems": "Mostrando {{shown}} de {{total}} elementos",
    "loadError": "No se han podido cargar los datos. Inténtalo de nuevo más tarde."
  },
  "header": {
    "loading": "Cargando",
    "refresh": "Actualizar",
    "download": "Descargar",
    "pdf": "PDF",
    "excel": "Excel",
    "share": "Compartir",
    "shareLink": "Enlace para compartir"
  },
  "filter": {
    "removeTag": "eliminar etiqueta",
    "types": {
      "all": "Todos",
      "location": "Ubicación",
      "installation": "Instalación",
      "campaign": "Campaña",
      "playlist": "Playlist",
      "zone": "Zona",
      "gate": "Acceso",
      "crossingLine": "Línea de cruce"
    },
    "listTitles": {
      "location": "UBICACIÓN",
      "installation": "INSTALACIÓN",
      "campaign": "CAMPAÑA",
      "playlist": "PLAYLIST",
      "zone": "ZONA",
      "gate": "ACCESO",
      "crossingLine": "LÍNEA DE CRUCE"
    },
    "viewMore": {
      "location": "Ver más ubicaciones",
      "installation": "Ver más instalaciones",
      "campaign": "Ver más campañas",
      "playlist": "Ver más playlists",
      "zone": "Ver más zonas",
      "gate": "Ver más accesos",
      "crossingLine": "Ver más líneas de cruce"
    }
  },
  "datePicker": {
    "selectDates": "Seleccionar fechas",
    "range": "Rango",
    "compareTo": "Comparar con",
    "month": "Mes",
    "year": "Año",
    "previousMonth": "Mes anterior",
    "nextMonth": "Mes siguiente",
    "periodA": "Periodo A",
    "periodB": "Periodo B",
    "rangePresets": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "1w": "1 semana",
      "2w": "2 semanas",
      "1m": "1 mes",
      "1y": "1 año",
      "custom": "Personalizado"
    },
    "comparePresets": {
      "prev-period": "Periodo anterior",
      "prev-month": "Mes anterior",
      "prev-quarter": "Trimestre anterior",
      "prev-year": "Año anterior",
      "custom": "Personalizado"
    },
    "strip": {
      "starts": "Empieza el {{date}}",
      "ends": "Termina el {{date}}"
    },
    "footer": {
      "daysEach_one": "{{count}} día cada uno",
      "daysEach_other": "{{count}} días cada uno",
      "bothTo": "{{length}}, ambos hasta {{cutoff}}",
      "lessThanAnHour": "ha pasado menos de una hora desde el inicio del día"
    },
    "cellAria": {
      "start": "{{date}}, inicio del periodo {{axis}}",
      "end": "{{date}}, fin del periodo {{axis}}",
      "single": "{{date}}, periodo {{axis}}",
      "within": "{{date}}, dentro del periodo {{axis}}"
    }
  },
  "compare": {
    "prev-period": "periodo anterior",
    "prev-month": "mes anterior",
    "prev-quarter": "trimestre anterior",
    "prev-year": "año anterior",
    "custom": "periodo anterior"
  },
  "cards": {
    "footfall": "Afluencia acum. / OTS",
    "topZones": "Zonas principales",
    "crossings": "Cruces",
    "topCrossingLines": "Líneas de cruce principales",
    "liveOccupancy": "Ocupación en tiempo real",
    "topGates": "Accesos principales",
    "peakTime": "Momento de máxima afluencia",
    "peakHour": "Hora punta",
    "offPeakTime": "Momento de mínima afluencia",
    "offPeakHour": "Hora valle",
    "totalPeople": "Total de personas",
    "traffic": "Tráfico",
    "watchers": "Espectadores",
    "dwellTime": "Tiempo de permanencia",
    "avgAttentionTime": "Tiempo medio de atención",
    "gender": "Género",
    "age": "Edad",
    "emotion": "Emoción",
    "interactionCoreMetrics": "Métricas principales de interacción",
    "interactions": "Interacciones",
    "interactionsLower": "interacciones",
    "rest": "Resto",
    "avgTime": "Tiempo medio",
    "topInteractedProduct": "Producto con más interacciones",
    "top5Products": "Top 5 productos",
    "historical": "Histórico"
  },
  "gender": {
    "Male": "Hombre",
    "Female": "Mujer",
    "Unknown": "Desconocido"
  },
  "age": {
    "Children (0-20)": "Niños (0-20)",
    "Young (21-40)": "Jóvenes (21-40)",
    "Middle Age (41-60)": "Mediana edad (41-60)",
    "Elder (61-99)": "Mayores (61-99)",
    "Unknown": "Desconocido"
  },
  "emotion": {
    "calm": "Calma",
    "happy": "Alegría",
    "surprise": "Sorpresa",
    "anger": "Enfado",
    "sad": "Tristeza"
  },
  "mediaPlayback": {
    "title": "Reproducción de contenidos",
    "searchPlaceholder": "Buscar contenido",
    "views": "Visualizaciones",
    "partially": "Parciales",
    "fully": "Completas",
    "totalViewsIn": "del total de visualizaciones en",
    "columns": {
      "media": "CONTENIDO",
      "campaign": "CAMPAÑA",
      "playlist": "PLAYLIST",
      "played": "REPRODUCCIONES",
      "views": "VISUALIZACIONES",
      "partially": "PARCIALES",
      "fully": "COMPLETAS"
    }
  },
  "productSales": {
    "title": "Ventas e ingresos",
    "family": "Familia",
    "product": "Producto",
    "brand": "Marca",
    "earnings": "Ingresos",
    "units": "Unidades",
    "columns": {
      "name": "NOMBRE",
      "code": "CÓDIGO",
      "media": "CONTENIDO",
      "totalPlays": "REPRODUCCIONES",
      "units": "UNIDADES",
      "totalSales": "VENTAS TOTALES"
    }
  },
  "historical": {
    "timeLapse": {
      "Hours": "Horas",
      "Days": "Días",
      "Months": "Meses",
      "Years": "Años"
    },
    "analyticTypes": {
      "traffic": "tráfico",
      "views": "espectadores",
      "dwell": "permanencia",
      "attention": "atención",
      "age": "edad",
      "gender": "género",
      "sales": "ventas",
      "gate": "acceso",
      "zone": "zona",
      "crossingLine": "línea de cruce"
    }
  },
  "dates": {
    "months": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "weekdays": [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo"
    ],
    "weekdaysShort": [
      "Do",
      "Lu",
      "Ma",
      "Mi",
      "Ju",
      "Vi",
      "Sá"
    ]
  },
  "pdf": {
    "account": "Cuenta",
    "location": "Ubicación",
    "installation": "Instalación",
    "campaign": "Campaña",
    "period": "Periodo"
  },
  "excel": {
    "sheets": {
      "byHour": "Por hora",
      "byWeekday": "Por día de la semana",
      "byMonth": "Por mes",
      "byYear": "Por año",
      "mediaPlayback": "Reproducción de contenidos"
    },
    "audienceHeader": [
      "Cuenta",
      "Ubicación",
      "Instalación",
      "Campaña",
      "Desde",
      "Hasta",
      "Periodo",
      "Tráfico",
      "Espectadores",
      "Permanencia",
      "Atención",
      "Niños",
      "Jóvenes",
      "Mediana edad",
      "Mayores",
      "Mujeres",
      "Hombres",
      "Tráfico total",
      "Espectadores totales",
      "Permanencia total",
      "Atención total",
      "Total niños",
      "Total jóvenes",
      "Total mediana edad",
      "Total mayores",
      "Total mujeres",
      "Total hombres"
    ],
    "mediaPlaybackHeader": [
      "Contenido",
      "Campaña",
      "Playlist",
      "Reproducciones",
      "Visualizaciones",
      "Parciales",
      "Completas"
    ]
  },
  "information": {
    "traffic": {
      "name": "Tráfico",
      "tooltip": "Personas detectadas dentro del área de interés definida, si se ha configurado una.",
      "moreInformation": "Cuenta las personas detectadas dentro del área de interés definida para esta instalación.\nSi no se ha configurado ningún área, cuenta todas las personas detectadas en el campo de visión de la cámara.\nNo indica si vieron algún contenido: quienes miraron la pantalla se cuentan como Espectadores."
    },
    "avgAttentionTime": {
      "name": "Tiempo medio de atención",
      "tooltip": "Tiempo medio que un Espectador miró activamente la pantalla.",
      "moreInformation": "Muestra cuánto tiempo miraron las personas la pantalla, de media.\n\nEjemplo:\n\nEspectador 1: mira durante 4 segundos\nEspectador 2: mira durante 6 segundos\nTiempo medio de atención: 5 segundos\n\nUna mirada se cuenta cuando la vista de una persona está dirigida a la pantalla durante al menos 0,5 segundos."
    },
    "watchers": {
      "name": "Espectadores",
      "tooltip": "Número de personas que miraron la pantalla.",
      "moreInformation": "Cuenta las personas que prestaron atención a la pantalla.\nMuestra cuántas personas vieron realmente el contenido.\nNo incluye a las personas que simplemente pasaron sin mirar."
    },
    "dwellTime": {
      "name": "Tiempo de permanencia",
      "tooltip": "Tiempo medio que una persona permanece dentro del área de interés, si se ha configurado una.",
      "moreInformation": "Muestra cuánto tiempo permanecen de media las personas en el área de interés, independientemente de si miraron la pantalla.\nPor ejemplo, si tres personas permanecen 10, 20 y 30 segundos, el Tiempo de permanencia es de 20 segundos."
    },
    "gender": {
      "name": "Género",
      "tooltip": "Porcentaje de hombres y mujeres detectados.",
      "moreInformation": "Muestra cómo se reparte la audiencia entre hombres y mujeres."
    },
    "age": {
      "name": "Edad",
      "tooltip": "Porcentaje de personas detectadas en cada grupo de edad.",
      "moreInformation": "Muestra cómo se distribuye la audiencia por grupos de edad.\nPor ejemplo: menores de 20, entre 21 y 40, o mayores de 60."
    },
    "emotion": {
      "name": "Emoción",
      "tooltip": "Expresiones faciales detectadas en los rostros de las personas.",
      "moreInformation": "Muestra si una expresión parece alegre, triste, sorprendida, enfadada o neutra.\nEs una estimación de la expresión visible, no de cómo se siente realmente la persona."
    },
    "mediaPlayback": {
      "name": "Reproducción de contenidos",
      "tooltip": "Resultados de cada anuncio o contenido mostrado en la pantalla.",
      "moreInformation": "Muestra cuántas veces se vio cada contenido y cuántas personas lo vieron.\nDistingue entre contenido visto parcialmente y contenido visto por completo.\nTambién muestra el coste equivalente en Meta y el tipo de audiencia que lo vio.\nLa tabla permite comparar resultados por archivo, campaña y playlist."
    },
    "views": {
      "name": "Visualizaciones",
      "tooltip": "Número total de veces que las personas miraron la pantalla.",
      "moreInformation": "Cada vez que alguien mira la pantalla, se cuenta una Visualización.\nUna misma persona puede generar varias Visualizaciones.\nEjemplo: si una persona mira la pantalla tres veces, cuenta como 1 Espectador y 3 Visualizaciones.\n\nUna mirada se cuenta cuando la vista de una persona está dirigida a la pantalla durante al menos 0,5 segundos."
    },
    "played": {
      "name": "Reproducciones",
      "tooltip": "Número de veces que este contenido se reprodujo en la pantalla.",
      "moreInformation": "Cuenta cuántas veces se reprodujo el anuncio, vídeo o imagen en la pantalla."
    },
    "mediaViews": {
      "name": "Visualizaciones",
      "tooltip": "Número total de veces que las personas miraron este contenido.",
      "moreInformation": "Cuenta cuántas veces las personas miraron el contenido.\nUna reproducción puede generar varias Visualizaciones, porque varias personas pueden verla y una misma persona puede mirar más de una vez.\nEjemplo: si el contenido se reproduce 10 veces y genera 25 miradas, entonces Reproducciones = 10 y Visualizaciones = 25.\n\nUna mirada se cuenta cuando la vista de una persona está dirigida a la pantalla durante al menos 0,5 segundos."
    },
    "partially": {
      "name": "Visualizaciones parciales",
      "tooltip": "Número de veces que alguien vio al menos el 30% del anuncio.",
      "moreInformation": "Cuenta las visualizaciones en las que la persona vio al menos el 30% pero menos del 70% del contenido.\nEjemplo: alguien ve 8 segundos de un anuncio de 20 segundos (40%)."
    },
    "fully": {
      "name": "Visualizaciones completas",
      "tooltip": "Número de veces que alguien vio al menos el 70% del anuncio.",
      "moreInformation": "Cuenta las visualizaciones en las que la persona vio el 70% o más del contenido.\nEjemplo: alguien ve 16 segundos de un anuncio de 20 segundos (80%)."
    },
    "cpmEquivalent": {
      "name": "CPM equivalente",
      "tooltip": "Coste estimado de conseguir el mismo número de Visualizaciones con anuncios de Meta.",
      "moreInformation": "Compara las Visualizaciones registradas por Broox con el coste medio de Meta por cada 1.000 impresiones.\nUna misma persona puede generar varias Visualizaciones."
    },
    "cpuEquivalent": {
      "name": "CPU equivalente",
      "tooltip": "Coste estimado de alcanzar el mismo número de personas únicas a través de Meta.",
      "moreInformation": "Compara los Espectadores de Broox con el coste de alcanzar personas únicas en Meta.\nCada persona se cuenta una sola vez, aunque mire varias veces."
    },
    "mostViewedProduct": {
      "name": "Producto más visto",
      "tooltip": "Producto que recibió el mayor número de Visualizaciones.",
      "moreInformation": "Muestra qué producto generó más Visualizaciones.\nEn este ejemplo, Camiseta de hombre recibió 1.282 Visualizaciones.\nEsto representa aproximadamente el 36% de las 3.551 Visualizaciones totales."
    },
    "media": {
      "name": "Contenido",
      "tooltip": "El archivo concreto mostrado en la pantalla.",
      "moreInformation": "Es el anuncio, vídeo o imagen que se reprodujo.\nPermite ver los resultados de cada contenido por separado."
    },
    "campaign": {
      "name": "Campaña",
      "tooltip": "La campaña a la que pertenece el contenido.",
      "moreInformation": "Agrupa varios anuncios o contenidos bajo una misma campaña.\nPermite comparar los resultados globales de la campaña y los de cada elemento individual."
    },
    "playlist": {
      "name": "Playlist",
      "tooltip": "Una lista de contenidos reproducidos juntos en un orden concreto.",
      "moreInformation": "Agrupa los vídeos o imágenes mostrados en la pantalla.\nMuestra en qué playlist se incluyó cada contenido."
    },
    "interactionCoreMetrics": {
      "name": "Métricas principales de interacción",
      "tooltip": "Resumen de las principales métricas de interacción con productos.",
      "moreInformation": "Muestra cuántas veces las personas interactuaron con los productos y la duración media de cada interacción.\nAyuda a entender cuánto interés generan los productos."
    },
    "interactions": {
      "name": "Interacciones",
      "tooltip": "Número total de veces que las personas interactuaron con un producto.",
      "moreInformation": "Cuenta cada vez que alguien coge, toca o mueve un producto.\nUna misma persona puede generar varias interacciones.\nEjemplo: si alguien coge dos productos, cuenta como 2 interacciones."
    },
    "avgTime": {
      "name": "Tiempo medio",
      "tooltip": "Duración media de cada interacción.",
      "moreInformation": "Muestra cuánto tiempo interactúan las personas con un producto, de media.\nEjemplo: si las interacciones duran 2, 4 y 6 segundos, el tiempo medio es de 4 segundos."
    },
    "topInteractedProduct": {
      "name": "Producto con más interacciones",
      "tooltip": "Producto con el mayor número de interacciones.",
      "moreInformation": "Muestra qué producto se tocó, cogió o movió más veces."
    },
    "top5Products": {
      "name": "Top 5 productos",
      "tooltip": "Los cinco productos con más interacciones.",
      "moreInformation": "Muestra los productos que se tocaron, cogieron o movieron más veces.\nEl número indica cuántas interacciones recibió cada producto.\nLa flecha indica si recibió más o menos interacciones que en el periodo anterior."
    },
    "historical": {
      "name": "Histórico",
      "tooltip": "Cómo evolucionan las métricas a lo largo del tiempo.",
      "moreInformation": "Muestra cómo cambian los datos durante el periodo seleccionado.\nPermite comparar métricas como Tráfico y Tiempo de atención por hora, día o semana.\nAyuda a identificar los momentos con más personas o con mayor atención."
    },
    "salesAndEarnings": {
      "name": "Ventas e ingresos",
      "tooltip": "Resumen de ventas e ingresos.",
      "moreInformation": "Muestra cuánto dinero se generó y cuántas unidades se vendieron.\nOfrece una visión rápida de los resultados comerciales del periodo seleccionado."
    },
    "earnings": {
      "name": "Ingresos",
      "tooltip": "Dinero total generado por las ventas.",
      "moreInformation": "Muestra el importe total generado durante el periodo seleccionado.\nLa flecha indica si aumentó o disminuyó respecto al periodo anterior."
    },
    "units": {
      "name": "Unidades",
      "tooltip": "Número total de productos vendidos.",
      "moreInformation": "Cuenta cuántas unidades se vendieron durante el periodo seleccionado.\nLa flecha muestra la diferencia respecto al periodo anterior."
    },
    "footfall": {
      "name": "Afluencia",
      "tooltip": "Personas que pasaron por un área, sin relación con una pantalla concreta.",
      "moreInformation": "Cuenta el movimiento o la presencia de personas en un espacio, independientemente de si tuvieron la oportunidad de ver algún contenido.\nEs la métrica básica de circulación.\nNo indica ningún tipo de exposición publicitaria."
    },
    "topZones": {
      "name": "Zonas principales",
      "tooltip": "Áreas con el mayor número de personas.",
      "moreInformation": "Muestra cómo se distribuye la Afluencia entre las distintas áreas del espacio.\nEl porcentaje indica qué parte del movimiento total se produjo en cada área.\nNo significa que esas personas vieran una pantalla o un anuncio; solo que estuvieron en esa área o pasaron por ella."
    },
    "peakTime": {
      "name": "Momento de máxima afluencia",
      "tooltip": "Momento del día con el mayor número de personas en el espacio.",
      "moreInformation": "Muestra cuándo se registró la mayor Afluencia.\nAyuda a identificar los momentos de más actividad."
    },
    "peakHour": {
      "name": "Hora punta",
      "tooltip": "Hora en la que se registró el mayor número de personas.",
      "moreInformation": ""
    },
    "totalPeople": {
      "name": "Total de personas",
      "tooltip": "Número de personas registradas durante el momento de más actividad.",
      "moreInformation": ""
    },
    "offPeakTime": {
      "name": "Momento de mínima afluencia",
      "tooltip": "Momento del día con el menor número de personas en el espacio.",
      "moreInformation": "Muestra cuándo se registró la menor Afluencia.\nAyuda a identificar los momentos más tranquilos."
    },
    "offPeakHour": {
      "name": "Hora valle",
      "tooltip": "Hora en la que se registró el menor número de personas.",
      "moreInformation": ""
    },
    "fewPeople": {
      "name": "Mínimo de personas",
      "tooltip": "Número de personas registradas en ese momento.",
      "moreInformation": ""
    },
    "liveOccupancy": {
      "name": "Ocupación en tiempo real",
      "tooltip": "Número de personas presentes ahora mismo en el espacio.",
      "moreInformation": "Muestra cuántas personas hay en el espacio en este momento.\nSe actualiza en tiempo real a medida que las personas entran o salen.\nEl gráfico muestra cómo ha cambiado la ocupación durante las últimas horas.\n\nEjemplo: si muestra 760, significa que hay aproximadamente 760 personas dentro del espacio en este momento."
    },
    "topGates": {
      "name": "Accesos principales",
      "tooltip": "Entradas o puntos de acceso utilizados por el mayor número de personas.",
      "moreInformation": "Muestra cómo se distribuye la Afluencia entre las distintas entradas.\nEl porcentaje indica qué parte del total pasó por cada entrada."
    },
    "entries": {
      "name": "Entradas",
      "tooltip": "Número de personas que entraron por cada área o punto de acceso.",
      "moreInformation": "Compara el número de entradas registradas en distintas ubicaciones.\nLos datos pueden agruparse por área o por puerta de entrada.\nLas barras más largas indican los lugares por los que entraron más personas.\nAyuda a identificar qué entradas tienen más tráfico."
    }
  }
}